import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Person from "../Person/Person";
import Surplus from "./Surplus";

export const getUserInfo = (user, companyName) => {
  if (!user || !user.person) {
    return null;
  }
  const {
    person: { id, firstName, lastName, phoneNumber, email, fax, phone },
    clientContacts = [],
  } = user;

  const clientContact = clientContacts.find(cc => cc.contactType);
  const contactType = clientContact ? clientContact.contactType : undefined;

  return {
    id,
    firstName,
    lastName,
    phoneNumber: phoneNumber || phone,
    email,
    fax,
    contactType,
    companyName,
  };
};

const getCompanyNameForMemberType = (memberType, project) => {
  const companyMapping = {
    "Project Manager": project?.projectManager?.name,
    "Secondary Project Manager": project?.secondaryProjectManager?.name,
    "Interior Designer": project?.designer?.name,
    "Secondary Interior Designer": project?.secondaryDesigner?.name,
    "General Contractor": project?.generalContractor?.name,
    Other: project?.otherConsultant?.name,
    "Freight Vendor": project?.freightVendor?.name,
    "Warehouse Vendor": project?.warehouseVendor?.name,
  };

  return companyMapping[memberType] || null;
};

export const getMembers = (members, { type, memberType, project }) => {
  const filteredMembers = memberType
    ? members.filter(member => member.memberType === memberType)
    : members;

  return filteredMembers
    .map(item => {
      const companyName =
        type === "contact"
          ? getCompanyNameForMemberType(item.memberType, project)
          : null;

      return getUserInfo(item[type], companyName);
    })
    .filter(member => member !== null);
};

const PersonList = ({
  maxTags,
  members,
  type,
  memberType,
  personTypeLabel,
  project,
}) => {
  maxTags = maxTags !== undefined ? maxTags : members.length;
  const filteredMembers = getMembers(members, { type, memberType, project });
  const displayMembers = filteredMembers.slice(0, maxTags);
  const surplusCount = filteredMembers.length - maxTags;
  return (
    <Fragment>
      {displayMembers.map((person, index) => (
        <Person
          key={index}
          person={person}
          isOverlap={index !== 0}
          personType={personTypeLabel}
          tabIndex="-1"
        />
      ))}
      {surplusCount > 0 && (
        <Surplus isOverlap={true} key="surplus">{`+${surplusCount}`}</Surplus>
      )}
    </Fragment>
  );
};

PersonList.propTypes = {
  maxTags: PropTypes.number,
  members: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      memberType: PropTypes.string,
    })
  ),
  memberType: PropTypes.string,
  personTypeLabel: PropTypes.string,
  type: PropTypes.oneOf(["user", "contact"]),
  project: PropTypes.shape({
    projectManager: PropTypes.shape({ name: PropTypes.string }),
    secondaryProjectManager: PropTypes.shape({ name: PropTypes.string }),
    designer: PropTypes.shape({ name: PropTypes.string }),
    secondaryDesigner: PropTypes.shape({ name: PropTypes.string }),
    generalContractor: PropTypes.shape({ name: PropTypes.string }),
    otherConsultant: PropTypes.shape({ name: PropTypes.string }),
    freightVendor: PropTypes.shape({ name: PropTypes.string }),
    warehouseVendor: PropTypes.shape({ name: PropTypes.string }),
  }),
};

PersonList.defaultProps = {
  members: [],
};

export default PersonList;
